module.exports = __webpack_public_path__ + "assets/img/goods-redarea-bg.e4b416f3.png";